export default __webpack_public_path__ + "locales/zh-CN/FormGallery.json?hash=e8019b90dc42760aeecbf48c6be2e6fc";